import { render, staticRenderFns } from "./AdminAddCoownerDialog.vue?vue&type=template&id=7af5aeb8"
import script from "./AdminAddCoownerDialog.vue?vue&type=script&lang=ts"
export * from "./AdminAddCoownerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports